export const unformatPhone = (phone: string) => phone.replace(/\D/g, '');

export function formatPhone(phone: string) {
  const phoneDigits = unformatPhone(phone);
  if (phoneDigits.length !== 11)
    return phone;

  return phoneDigits.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5');
}
